import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';

import { ListPaginationStyle } from './ListPaginationStyle';

const ListPagination = ({ page, pageAmount, handleClickPagination }) => {
  const renderPagainationButtonDomList = useMemo(() => {
    if (pageAmount && pageAmount > 0) {
      const pagainationButtonDomList = [];

      for (let i = 0; i < pageAmount; i += 1) {
        pagainationButtonDomList.push(
          <button
            key={uuidV4()}
            className="list-pagination-button"
            type="button"
            onClick={() => handleClickPagination(i)}
            disabled={i === page}
          >
            {i + 1}
          </button>
        );
      }

      if (pagainationButtonDomList && pagainationButtonDomList.length) {
        return pagainationButtonDomList;
      }
    }

    return null;
  }, [handleClickPagination, page, pageAmount]);

  const lastPage = useMemo(() => {
    const currentLastPage = page - 1;

    if (currentLastPage >= 0) {
      return currentLastPage;
    }

    return 0;
  }, [page]);

  const nextPage = useMemo(() => {
    const currentNextPage = page + 1;

    if (currentNextPage <= pageAmount) {
      return currentNextPage;
    }

    return pageAmount;
  }, [page, pageAmount]);

  return (
    <ListPaginationStyle>
      <div className="list-pagination-container">
        <button
          className="list-pagination-button step-page-button"
          type="button"
          onClick={() => handleClickPagination(lastPage)}
          disabled={page === 0}
        >
          {'<<'}
        </button>
        {renderPagainationButtonDomList}
        <button
          className="list-pagination-button step-page-button"
          type="button"
          onClick={() => handleClickPagination(nextPage)}
          disabled={page === pageAmount - 1}
        >
          {'>>'}
        </button>
      </div>
    </ListPaginationStyle>
  );
};

ListPagination.propTypes = {
  pageAmount: PropTypes.number,
  page: PropTypes.number,
  handleClickPagination: PropTypes.func.isRequired,
};

ListPagination.defaultProps = {
  pageAmount: 0,
  page: 0,
};

export default ListPagination;
